/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} System_Logo_AltInputs */



/**
* | output |
* | --- |
* | "System Logo" |
*
* @param {System_Logo_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const system_logo_alt = /** @type {((inputs?: System_Logo_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<System_Logo_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Logo du systeme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Systemlogo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Logo del sistema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Логотип системы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Logotipo del sistema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("系统标志")
	if (locale === "ja") return /** @type {LocalizedString} */ ("システムロゴ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिस्टम लोगो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Logotipo do sistema")
	return /** @type {LocalizedString} */ ("System Logo")
});